module.exports = __webpack_public_path__ + "static/media/fish-vector.41464f9e.svg";